import type { PhotoRecordDto, UserPublic } from '@forest/contracts';

/**
 * Mirrors the server's `canMutatePhoto` (services/scope.ts) so the page only
 * offers edits the API will accept. The server stays the authority.
 */
export function canEditPhoto(
  user: Pick<UserPublic, 'id' | 'role' | 'assignedEntitatiSilvice'> | null | undefined,
  photo: Pick<PhotoRecordDto, 'userId' | 'entitateSilvica' | 'parcel'>,
): boolean {
  if (!user) return false;
  switch (user.role) {
    case 'SUPER_ADMIN':
    case 'CONTROLOR':
      return true;
    case 'ADMINISTRATOR': {
      if (photo.userId === user.id) return true;
      const entities = new Set(user.assignedEntitatiSilvice);
      return (
        (photo.entitateSilvica !== null && entities.has(photo.entitateSilvica)) ||
        (photo.parcel?.entitateSilvica != null && entities.has(photo.parcel.entitateSilvica))
      );
    }
    case 'AJUTOR_ADMINISTRATOR':
      return photo.userId === user.id;
    default:
      return false;
  }
}
